/**
 * NOS-5: Reusable icon button for builder UI.
 * All specs from docs/specs/BUILDER_DESIGN_SPEC.md Section 10.
 */
import type { ButtonHTMLAttributes } from "react"

export interface IconBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Override default 26px size, e.g. 22 for element controls */
  size?: number
  /** Danger variant: red color */
  danger?: boolean
  /** Active/pressed state */
  active?: boolean
  /** Icon or character to display */
  children: React.ReactNode
}

export function IconBtn({
  size = 26,
  danger = false,
  active = false,
  children,
  style,
  ...props
}: IconBtnProps) {
  return (
    <button
      type="button"
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
        fontSize: 11,
        cursor: "pointer",
        flexShrink: 0,
        transition: "all 0.12s",
        fontFamily: "'DM Sans', sans-serif",
        background: active ? "rgba(255,255,255,0.12)" : "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.06)",
        color: danger ? "#ef4444" : active ? "#fff" : "rgba(255,255,255,0.4)",
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  )
}
